var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFullStorageIllustration = function SvgFullStorageIllustration(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M57.43 31.58 47.35 60.43l28.849 10.08 10.08-28.849-28.85-10.08Z",
    fill: "#116DFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M98 74H74l5-14h24l-5 14Z",
    fill: "#C2E2FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M63 66.5C63 57.94 56.06 51 47.5 51 38.94 51 32 57.94 32 66.5 32 75.06 38.94 82 47.5 82 56.06 82 63 75.06 63 66.5Z",
    fill: "#192C55"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m88.12 80.2-13.63 6.6a12.27 12.27 0 0 1-17.596-10.32 12.258 12.258 0 0 1 6.896-11.75l13.64-6.61a12.27 12.27 0 0 1 16.38 5.69 12.27 12.27 0 0 1-5.69 16.39ZM69 13a6 6 0 1 0-12 0 6 6 0 0 0 12 0Z",
    fill: "#28BF9A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M98 111H22V74h76v37ZM78 22.21a5.6 5.6 0 0 0-6.51-4.5l-25.9 4.72A5.597 5.597 0 0 0 41 28.94a5.6 5.6 0 0 0 6.51 4.5l25.89-4.72a5.601 5.601 0 0 0 4.6-6.51ZM46 74H22l-5-14h24l5 14Z",
    fill: "#C2E2FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M79 74h-8v12h8V74Z",
    fill: "#fff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M46 75H22v-1h24v1Zm0 0h-1v36h1V75Z",
    fill: "#192C55"
  })));
};
export default SvgFullStorageIllustration;